import React, { Component } from 'react';
import Radium from 'radium';
import { semanticColors, greyScaleColors } from '../../../Globals/styles';
import { getFullDateString } from '../../../Util/dateTime';


class DailyreportsList extends Component {
    render() {
        const { dailyReports, toggleApproved, toggleInvoiced, goToDailyReport, workplaceId, workplaces } = this.props;

        var Items = dailyReports.map((dailyReport, index) => {
            return (
                <div key={index} className="waves-btn" style={[styles.row, index === dailyReports.length - 1 && styles.lastRow]}>

                    {/* <div style={styles.checkContainer}>
                        {!dailyReport.approved ?
                            <button type="button"
                                title="Godkend dagrapport"
                                className="btn btn-default"
                                style={{ borderRadius: 0 }}
                                onClick={() => toggleApproved(index, dailyReport.id, true)}>G</button>
                            :
                            <button type="button"
                                title="Godkend dagrapport"
                                className="btn btn-info"
                                style={{ borderRadius: 0 }}
                                onClick={() => toggleApproved(index, dailyReport.id, false)}>G</button>

                        }
                        {!dailyReport.invoiced ?
                            <button type="button"
                                title="Fakturer dagrapport"
                                className="btn btn-default"
                                style={{ borderRadius: 0 }}
                                onClick={() => toggleInvoiced(index, dailyReport.id, true)}>F</button>
                            :
                            <button type="button"
                                title="Fakturer dagrapport"
                                className="btn btn-info"
                                style={{ borderRadius: 0 }}
                                onClick={() => toggleInvoiced(index, dailyReport.id, false)}>F</button>
                        }
                    </div> */}
                    <div style={[styles.dailyReportContainer]} onClick={() => goToDailyReport(new Date(dailyReport.date), dailyReport.id, dailyReport.workplaceId)}>
                        <div className="pull-left" style={{ paddingLeft: 5, paddingRight: 5, width: 230, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden', textAlign: 'left' }}>{workplaces[dailyReport.workplaceId] ? workplaces[dailyReport.workplaceId].name : ''}</div>
                        <div className="pull-left" style={{ paddingRight: 10, width: 146 }}>{getFullDateString(new Date(dailyReport.date), true)}</div>
                        <div className="pull-right" style={{ width: 48, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{dailyReport.creationTime}</div>
                        <div className="pull-right" style={{ paddingRight: 10, fontWeight: 600 }}>#{dailyReport.version}</div>
                    </div>
                </div >
            )
        })

        return (
            <div style={{ height: '590px' }}>
                <div style={styles.Heading}>
                    <div style={styles.headingText}>Dagrapporter fra hele afdelingen</div>
                    <div style={[styles.headingText, { textAlign: 'left' }]}>
                        <div style={{ display: 'inline-block', width: 275 }}>Arbejdssted</div>
                        <div style={{ display: 'inline-block', width: 96 }}>Dato</div>
                        <div style={{ display: 'inline-block', width: 45 }}>Nr.</div>
                        <i className="fa fa-clock-o" aria-hidden="true"></i>

                    </div>
                </div>
                <div style={styles.listsContainer}
                    ref={(divElement) => this.divElement = divElement}
                    onScroll={(e) => {
                        if (this.divElement.scrollHeight - this.divElement.scrollTop < this.divElement.clientHeight + (dailyReports.length * 6)) {
                            this.props.moreDailies(dailyReports.length)
                        }
                    }}
                >
                    {Items}
                </div>
            </div >

        );
    }
}


var styles = {
    listsContainer: {
        backgroundColor: '#fff',
        borderRadius: '2px',
        overflowY: 'scroll',
        marginRight: '-15px',
        height: '90%',
        scrollBehavior: 'smooth',
        WebkitOverflowScrolling: 'touch'
    },
    row: {
        borderBottom: '1px solid',
        borderColor: semanticColors.mainBackground,
        fontSize: '12px',
        position: 'relative',
        padding: '0px',
        borderRadius: '0px'
    },
    dailyReportContainer: {
        // paddingLeft: '70px',
        height: '38px',
        lineHeight: '38px',
        cursor: 'pointer'
    },
    linkIcon: {
        position: 'absolute',
        top: '0px',
        right: '65px',
        fontWeight: '600'
    },
    time: {
        float: 'right'
    },
    checkContainer: {
        position: 'absolute',
        left: '0px',
        fontSize: '20px',
        top: '2px'
    },
    isChecked: {
        color: semanticColors.text
    },
    lastRow: {
        borderBottom: 'none'
    },
    Heading: {
        paddingBottom: '1px',
        position: 'relative'
    },
    headingText: {
        display: 'inline-block',
        backgroundColor: 'white',
        width: '103.6%',
        padding: '5px',
        textAlign: 'center',
        fontSize: '14px',
        fontWeight: 600,
    },
    headingCheckContainer: {
        position: 'absolute',
        left: '115px',
        top: '3px'
    },
    headingCheckContainerTwo: {
        left: '170px'
    },
    headingCheck: {
        fontSize: '18px',
        color: greyScaleColors.greyLight
    },
    headingCheckTwo: {
        color: greyScaleColors.greyLight
    },
    headingCheckText: {
        position: 'absolute',
        left: '17px',
        top: '-2px',
        width: '40px'
    }
}

export default Radium(DailyreportsList)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Kanban/DepartmentDailyreports/dailiesList.js